import { useEffect, useState } from 'react';

interface useAsyncOptions {
  fetch?: boolean
}

export const useAsync = <T>(cb: () => Promise<T>, options:useAsyncOptions = {} as useAsyncOptions) => {
  const _options = {
    fetch: false,
    ...options
  };

  const [data, setData] = useState<T|null>(null);
  const [error, setError] = useState<any>(null);
  const [state, setState] = useState({
    hasExecuted: false,
    isLoading: false,
    isSuccess: false,
    isError: false,
  });

  const exec = () => {
    setState({ ...state, isLoading: true });
    cb()
      .then((result: any) => {
        setState({
          hasExecuted: true,
          isLoading: false,
          isSuccess: true,
          isError: false
        });
        setData(result);
        setError(null);
      })
      .catch((e: any) => {
        setState({
          hasExecuted: true,
          isLoading: false,
          isSuccess: false,
          isError: true
        });
        setData(null);
        setError(e);
      });
  };

  useEffect(() => {
    if (_options.fetch) {
      exec();
    }
  }, []);

  return {
    ...state,
    error,
    data,
    exec
  };
};
